import React, { PropsWithChildren } from 'react';

import { clsx } from 'clsx';

import buttonStyle from '~/src/common/components/Button/Variants/PrimaryButton.module.scss';

import styles from './RecipeButton.module.scss';

type Props = PropsWithChildren<{
  onClick: () => void;
}>;

export const RecipeButton = ({ onClick, children }: Props) => {
  return (
    <button className={clsx(styles.recipeButton, buttonStyle.primaryButton)} onClick={onClick}>
      {children}
    </button>
  );
};
